function isVisible(el) {
  return el.style.display !== 'none' && el.style.display !== ''
    || (el.style.display === '' && getComputedStyle(el).display !== 'none')
}

/**
 * Watch all `.w-form-done` elements within `root` and call `onSuccess`
 * the first time any of them becomes visible.
 * @param {HTMLElement} root - container to watch (document.body or a popup)
 * @param {() => void} onSuccess
 * @returns {() => void} stop function
 */
export function watchFormsForSuccess(root, onSuccess) {
  const doneEls = root.querySelectorAll('.w-form-done')
  if (doneEls.length === 0) return () => {}

  // Skip elements that are already visible — we only want to detect transitions
  const initiallyHidden = new Set()
  doneEls.forEach(el => {
    if (!isVisible(el)) initiallyHidden.add(el)
  })

  let fired = false
  const observer = new MutationObserver(mutations => {
    if (fired) return
    for (const m of mutations) {
      if (m.type !== 'attributes' || m.attributeName !== 'style') continue
      const target = m.target
      if (!initiallyHidden.has(target)) continue
      if (isVisible(target)) {
        fired = true
        onSuccess()
        observer.disconnect()
        return
      }
    }
  })

  doneEls.forEach(el => {
    observer.observe(el, { attributes: true, attributeFilter: ['style'] })
  })

  return () => observer.disconnect()
}
